<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import axios from 'axios';
import AdvanceTable from "../tables/componentAdvanceTable";

import {
  required,
  //email,
  minLength,
  //sameAs,
  maxLength,
  //minValue,
  //maxValue,
  //numeric,
  //url,
  //alphaNum
} from "vuelidate/lib/validators";

/**
 * Form validation component
 */
export default {
  page: {
    title: "",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, AdvanceTable },
  props:{
    id:[Number,null],
  },
  data() {
    return {
      title: "Category",
      items: [
        {
          text: "Equipment",
          href: "/"
        },
        {
          text: "Categories",
          href: "/equipment/categories"
        },
        {
          text: "Category",
          active: true
        }
      ],

      form: {
        nm_category:    "",
        sn_calibration: false,
      },
      actions:{view:false, edit:true},
      submitted: false,
      user: {},

      categories: [],

      categoryMaintenances: [],
      categoryCleanings: [],
      categoryCalibrations: [],

      categoryMaintenancesColumns: [
        {label: "ID",           field:"id_maintenance",             key:"id_maintenance",             sortable:"true"},
        {label: "Frecuency",    field:"de_timeFrecuency",           key:"de_timeFrecuency",           sortable:"true"},
        {label: "Procedure",    field:"de_description",             key:"de_description",             sortable:"true"},
        {label: "Actions",      field:"action",                     key:"actions",                    tdClass:"actionsFixed"},
      ],
      categoryCleaningsColumns: [
        {label: "ID",           field:"id_cleaning"   ,             key:"id_cleaning",                sortable:"true"},
        {label: "Frecuency",    field:"de_timeFrecuency",           key:"de_timeFrecuency",           sortable:"true"},
        {label: "Procedure",    field:"de_description",             key:"de_description",             sortable:"true"},
        {label: "Actions",      field:"action",                     key:"actions",                    tdClass:"actionsFixed"},
      ],
      categoryCalibrationsColumns: [
        {label: "ID",           field:"id_calibration",             key:"id_calibration",             sortable:"true"},
        {label: "Frecuency",    field:"de_timeFrecuency",           key:"de_timeFrecuency",           sortable:"true"},
        {label: "Activity",     field:"de_calibrationActivity",     key:"de_calibrationActivity",     sortable:"true"},
        {label: "Responsible",  field:"de_calibrationResponsible",  key:"de_calibrationResponsible",  sortable:"true"},
        {label: "Procedure",    field:"de_description",             key:"de_description",             sortable:"true"},
        {label: "Actions",      field:"action",                     key:"actions",                    tdClass:"actionsFixed"},
      ],
    };
  },
  validations: {
    form: {
      nm_category: {required, minLength: minLength(2), maxLength: maxLength(50)},
      sn_calibration: { required },
    }
  },
  watch:{},
  created(){
    if(localStorage){
      this.user = JSON.parse( localStorage.getItem('user') );
    }
  },
  mounted() {
    if( this.$route.params.id ){
      this.id_category = this.$route.params.id;
      this.form['id_category'] = this.$route.params.id;
      this.getCategoryByID( this.$route.params.id );
      this.getCategoryMaintenancesByCategoryID();
      this.getCategoryCleaningsByCategoryID();
      this.getCategoryCalibrationsByCategoryID();
    }
    appConfig.title = function(){
      return "dsdas";
    };
  },
  methods: {
    getCategoryByID(idCategory){
      let app = this;

      Swal.fire({
        title: "Loading category data.",
        showConfirmButton:false,
        onBeforeOpen: () => {
          Swal.showLoading();
        }
      });


      axios
      .get(
        window.serverPath+'dist/mvw/controllers/categories.php',
        {
          params: {
            request: 'getCategoryByID',
            id: idCategory
          }
        }
      )
      .then(response => {
        console.log(response);
        Swal.close();
        if( response.statusText == "OK" ){
          if(response.data){
            app.form.id_category    = response.data.id_category;
            app.form.nm_category    = response.data.nm_category;
            app.form.sn_calibration = (response.data.sn_calibration == 1)? true :  false;
          }else{
            Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        }else{
          Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
        }
      })
      .catch(function (error) {
        console.log(error);
        app.isLoading = false;
        if(
          error.code == "ERR_BAD_RESPONSE"    ||
          error.code == "ERR_NETWORK"
        ){
          Swal.fire('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
        }
      });
    },

    getCategoryMaintenancesByCategoryID(){
      let app = this;

      axios
      .get(
        window.serverPath+'dist/mvw/controllers/maintenances.php',
        {
          params: {
            request:      'getCategoryMaintenancesByCategoryID',
            idCategory:   app.$route.params.id
          }
        }
      )
      .then(response => {
        Swal.close();
        if( response.statusText == "OK" ){
          if(response.data){
            app.categoryMaintenances = response.data;
          }else{
            Swal('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        }else{
          Swal('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
        }
      })
      .catch(function (error) {
        app.isLoading = false;
        if(
          error.code == "ERR_BAD_RESPONSE"    ||
          error.code == "ERR_NETWORK"
        ){
          Swal('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
        }
      });
    },

    getCategoryCleaningsByCategoryID(){
      let app = this;

      axios
      .get(
        window.serverPath+'dist/mvw/controllers/cleanings.php',
        {
          params: {
            request:      'getCategoryCleaningsByCategoryID',
            idCategory:   app.$route.params.id
          }
        }
      )
      .then(response => {
        Swal.close();
        if( response.statusText == "OK" ){
          if(response.data){
            app.categoryCleanings = response.data;
          }else{
            Swal('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        }else{
          Swal('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
        }
      })
      .catch(function (error) {
        app.isLoading = false;
        if(
          error.code == "ERR_BAD_RESPONSE"    ||
          error.code == "ERR_NETWORK"
        ){
          Swal('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
        }
      });
    },

    getCategoryCalibrationsByCategoryID(){
      let app = this;

      axios
      .get(
        window.serverPath+'dist/mvw/controllers/calibrations.php',
        {
          params: {
            request:      'getCategoryCalibrationsByCategoryID',
            idCategory:   app.$route.params.id
          }
        }
      )
      .then(response => {
        Swal.close();
        if( response.statusText == "OK" ){
          if(response.data){
            app.categoryCalibrations = response.data;
          }else{
            Swal('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        }else{
          Swal('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
        }
      })
      .catch(function (error) {
        app.isLoading = false;
        if(
          error.code == "ERR_BAD_RESPONSE"    ||
          error.code == "ERR_NETWORK"
        ){
          Swal('Ooops!!!','<p><b>Something wrong with the communication between your computer and our server.<br>Please check your internet connection.</b></p>','error');
        }
      });
    },


    // eslint-disable-next-line no-unused-vars
    saveCategory(e) {
      let app = this;
      let successMessage = "";

      this.submitted = true;

      // stop here if form is invalid
      this.$v.$touch();
      
      if( !this.$v.form.$error ){
        if( this.$route.params.id ){
          this.form.id_category = this.$route.params.id;
        }

        Swal.fire({
          title: "Saving category.",
          showConfirmButton:false,
          onBeforeOpen: () => {
            Swal.showLoading();
          }
        });

        axios.post(window.serverPath+'dist/mvw/controllers/categories.php', {
          request: 'saveCategory',
          data: this.form, 
        })
        .then(function (response) {
          let action = "";

          if(response.status == 500){ app.$router.push({ name: 'Error-500' }); }
          if(response.status == 404){ app.$router.push({ name: 'Error-404' }); }
          if(response.status == 401){ app.$router.push({ name: 'Error-401' }); }
          
          if( response.data === "OK" ){
            action = "saved";
          }
          if( response.data === "UPDATED" ){
            action = "updated";
          }

          Swal.fire("Good job!", "The category is correct "+action+"!", "success");
          app.$router.push({ name: 'categories' });



          if(response.data){
            Swal.fire(
              'Congrats!!!','<p><b>'+successMessage+'</b></p>',
              'success',
            ).then((result) => {
              /* Read more about isConfirmed, isDenied below */
              if (result.isConfirmed) {
                app.$router.push({ name: 'categories'});
              }
            });
          }else{
            Swal.fire('Ooops!!!','<p><b>Seems like an error had just occured.<br>Please try again.</b></p>','error');
          }
        })
        .catch(function (error) {
          Swal.fire("Ooops!" + error.message, "Seems like some error ocurr, please try again.", "error");
        });

        /*
        Swal.fire("Good job!", "Your industry is saved now!", "success")
        .then(() => {
          self.submitted = false;
          self.form.id_category       = "";
          self.form.nm_category = "";
        });
        */
      }
    },

    resetSite(){
      this.form.nm_category = "";
    }
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />


    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <form class="needs-validation" @submit.prevent="saveCategory">
              <div class="row">
                <div class="col-lg-4" >
                  <h4 class="card-title">Category</h4>
                  <p class="card-title-desc">Register a new industry into the system.</p>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label for="nm_category">Category name</label>
                        <input
                          type="text"
                          class="form-control"
                          :class="{ 'is-invalid': submitted && $v.form.nm_category.$error }"
                          name="nm_category"
                          id="nm_category"
                          v-model="form.nm_category"
                          value=""
                        >
                        <div v-if="submitted && $v.form.nm_category.$error" class="invalid-feedback">
                          <span v-if="!$v.form.nm_category.required">Category name is required.</span>
                          <span v-if="!$v.form.nm_category.minLength">This value length is invalid. It should be between 2 and 50 characters long.</span>
                          <span v-if="!$v.form.nm_category.maxLength">This value length is invalid. It should be between 2 and 50 characters long.</span>
                        </div>
                      </div>

                      <div class="form-group">
                        <b-form-checkbox v-model="form.sn_calibration" switch class="mb-1">
                          <label>Does this category need calibration?</label>
                        </b-form-checkbox>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-lg-8">
                  <div class="row">
                    <div class="col-md-12">
                      <AdvanceTable
                        :menu="'Equipment'"
                        :entity="'maintenance'"
                        :addLink="'/equipment/maintenances'"
                        :modalType="'modal'"
                        :component="'CategoryMaintenance'"
                        :idEntity="form.id_category"
                        @reload="getCategoryMaintenancesByCategoryID"
                        :datas="categoryMaintenances"
                        :columns="categoryMaintenancesColumns"
                        :actions="actions"
                      />
                    </div>
                  </div>

                  <div class="row">
                    <div class="col-md-12">
                      <AdvanceTable
                        :menu="'Equipment'"
                        :entity="'cleaning'"
                        :addLink="'/equipment/cleanings'"
                        :modalType="'modal'"
                        :component="'CategoryCleaning'"
                        :idEntity="form.id_category"
                        @reload="getCategoryCleaningsByCategoryID"
                        :datas="categoryCleanings"
                        :columns="categoryCleaningsColumns"
                        :actions="actions"
                      />
                    </div>
                  </div>

                  <div class="row" v-if="form.sn_calibration">
                    <div class="col-md-12">
                      <AdvanceTable
                        :menu="'Equipment'"
                        :entity="'calibration'"
                        :addLink="'/equipment/calibrations'"
                        :modalType="'modal'"
                        :component="'CategoryCalibration'"
                        :idEntity="form.id_category"
                        @reload="getCategoryCalibrationsByCategoryID"
                        :datas="categoryCalibrations"
                        :columns="categoryCalibrationsColumns"
                        :actions="actions"
                      />
                    </div>
                  </div>
                </div>

                <!--
                <div class="col-lg-4">
                </div>
                -->
              </div>

              <div class="row">
                <div class="col-lg-12 mt-5 pt-5">
                  <div class="form-group text-center">
                    <button class="btn btn-success" type="submit">SAVE CATEGORY</button>
                    <router-link to="/equipment/categories" class="ml-3">
                      <button class="btn btn-danger" type="reset">CANCEL </button>
                    </router-link>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>